import React from "react";
import {
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaVideo,
  FaCube,
} from "react-icons/fa";

// ---------------------------------------------------------------------------
const Button = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`bg-blue-600 hover:bg-blue-700 text-white font-semibold px-3 py-1.5 rounded-md text-sm ${className}`}
  >
    {children}
  </button>
);

const Pill = ({ icon, value }) => (
  <span className="flex items-center gap-1 bg-gray-light/80 text-xs text-text-dark px-2 py-1 rounded">
    {icon}
    {value}
  </span>
);

const Badge = ({ icon, label }) => (
  <span className="flex items-center gap-1 bg-gray-light/80 text-text-dark text-xs font-semibold px-2 py-1 rounded uppercase">
    {icon}
    {label}
  </span>
);

export default function ApartmentCard({ listing, onSelect }) { // This is not needed for the diff
  if (!listing) return null;

  const {
    imageUrl,
    name = "Propriété Sans Nom",
    price,
    location,
    fullDetailsForPanel,
    additional_details = {},
  } = listing;

  const beds = additional_details.hs_bedrooms ?? additional_details.bedrooms;
  const baths = additional_details.hs_bathrooms ?? additional_details.bathrooms;
  const area = additional_details.hs_square_footage ?? additional_details.surface;
  const place = location ?? additional_details.hs_address_1 ?? null;

  const has3D = Boolean(fullDetailsForPanel?.glbModelUrl);
  const hasVideo = Boolean(fullDetailsForPanel?.videoUrl);
  const priceStr = price ? Number(price).toLocaleString("fr-FR") + " MAD" : null;

 return (
    <div className={`relative flex items-center gap-3 rounded-xl bg-white backdrop-blur-lg border p-3 transition shadow-md`}>
      {/* Thumbnail */}
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="w-[120px] h-[88px] object-cover rounded-lg" />
        ) : (
          <div className="w-[120px] h-[88px] bg-gray-light text-gray-medium flex items-center justify-center text-xs rounded-lg">
            Image
          </div>
        )}
        <div className="absolute top-1 left-1 flex gap-0.5">
          {has3D && <Badge icon={<FaCube />} label="3D" />}
          {hasVideo && <Badge icon={<FaVideo />} label="Vidéo" />}
      </div>

      {/* Content */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <h3 className="text-base font-semibold text-text-dark truncate">{name}</h3>
        {place && (
          <p className="text-sm flex items-center gap-1 text-gray-medium truncate">
            <FaMapMarkerAlt className="text-sm" /> {place}
          </p>
        )}
        {(beds || baths || area) && (
          <div className="flex gap-1 flex-wrap">
            {beds && <Pill icon={<FaBed className="text-sm" />} value={beds} />}
            {baths && <Pill icon={<FaBath className="text-sm"/>} value={baths} />}
            {area && <Pill icon={<FaRulerCombined className="text-sm"/>} value={`${area} m²`} />}
          </div>
        )}
      </div>

      {/* CTA */}
      <div className="flex flex-col items-end justify-between">
        <Button onClick={onSelect} className="shrink-0 mb-3">Détails</Button>
      </div>
      {priceStr && (
        <span className="absolute bottom-3 right-3 bg-yellow-500 text-gray-900 text-xs font-bold px-2 py-1 rounded whitespace-nowrap">
          {priceStr}
        </span>
      )}
    </div>
  );
}
